const styles = ({ BREAKPOINTS }) => ({
  container: {
    width: '100%',
    padding: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '33.333%'
    }
  },
  sizeM: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '66.666%'
    }
  },
  sizeL: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '100%'
    }
  }
})

export default styles
